import React, { useEffect, useState } from 'react';

import { ExpandCollapse } from '@tds/core-expand-collapse';
import moment from 'moment-timezone';

import PropTypes from 'prop-types';
import Heading from '@tds/core-heading';

import request from '../../../../../utils/request';
import {
  OrderHistoryMain,
  OrderHistoryDataMain,
  OrderHistoryTimestamp,
  OrderHistoryAction
} from '../css';
import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const OrderHistory = ({ orderData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { orderHistory }
  } = localizedStrings;
  const [orderHistoryData, setOrderHistoryData] = useState();

  useEffect(() => {
    const { id } = orderData;
    request.get(`/orders/${id}/order-history`).then(result => {
      setOrderHistoryData(result.data);
    });
  }, []);

  const getLocalFormattedTime = (date, time) => {
    const localZone = moment.tz.guess();
    const format = 'hh:mm A';
    const dateTime = `${date} ${time}`;

    return `${moment
      .utc(dateTime)
      .local()
      .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
  };

  return (
    <>
      <Heading level="h3">{orderHistory}</Heading>
      <OrderHistoryMain>
        {orderHistoryData &&
          Object.keys(orderHistoryData).map(date => {
            return (
              <ExpandCollapse tag="h2" topDivider={false}>
                <ExpandCollapse.Panel id={date} header={date}>
                  {orderHistoryData[date].map(data => (
                    <OrderHistoryDataMain>
                      <OrderHistoryTimestamp>
                        {getLocalFormattedTime(date, data.timeStamp)}
                      </OrderHistoryTimestamp>
                      <OrderHistoryAction>{`${data.action} by ${data.user}`}</OrderHistoryAction>
                    </OrderHistoryDataMain>
                  ))}
                </ExpandCollapse.Panel>
              </ExpandCollapse>
            );
          })}
      </OrderHistoryMain>
    </>
  );
};

OrderHistory.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired
};

export default OrderHistory;
